import { baseURL } from "../utils/url";

export const getCustomerSchema = async (clientId) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetCustomerSchemaFields?clientId=${clientId}`, {
            method: "GET",
            headers: {
              
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const getTransactionSchema = async (clientId) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetTransactionSchemaFields?clientId=${clientId}`, {
            method: "GET",
            headers: {
              
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const UpdateCustomerSchema = async (id,isDisplay,ident) => {
    try {
        const fetchResponse = await fetch(baseURL + `UpdateCustomerSchemaFields?id=${id}&isDisplay=${isDisplay}&ident=${ident}`, {
            method: "GET",
            headers: {
              
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const UpdateTransactionSchema = async (id,ident) => {
    try {
        const fetchResponse = await fetch(baseURL + `UpdateTransactionSchemaFields?id=${id}&ident=${ident}`, {
            method: "GET",
            headers: {
              
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const createCustomerSchema = async (body) => {
    try {
        const fetchResponse = await fetch(baseURL + "PostCustomerSchemaFields", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const createTransactionSchema = async (body) => {
    try {
        const fetchResponse = await fetch(baseURL + "PostTransactionSchemaFields", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};